import { useEffect, useRef } from 'react';

/**
 * Auto-dismiss a tooltip on scroll (mobile/touch only).
 * Desktop hover-tooltips are unaffected.
 *
 * Usage:
 *   useScrollDismiss(challengeTip, setChallengeTip);
 */
export function useScrollDismiss<T>(value: T, setter: (v: T) => void): void {
  const setterRef = useRef(setter);
  setterRef.current = setter;

  useEffect(() => {
    if (!value) return;
    // Only on touch devices
    if (!window.matchMedia('(hover: none)').matches) return;

    const close = () => setterRef.current(null as T);
    window.addEventListener('scroll', close, { once: true, capture: true });
    window.addEventListener('resize', close, { once: true });

    return () => {
      window.removeEventListener('scroll', close);
      window.removeEventListener('resize', close);
    };
  }, [value]);
}
